import React from "react";
import { Link } from "react-router-dom";
import AnimatedSection from "../animation/AnimatedSection"; // Make sure this component exists
import "./Aboutus.css";
const AboutUs = () => {
  return (
    <>
      {/* <header className="bg-danger text-white py-5 px-4">
        <div className="container-fluid">
          <h1 className="display-4 fw-bold mb-3">About Us</h1>
          <nav className="d-flex align-items-center gap-2 small">
            <i className="fas fa-home"></i>
            <Link to="/" className="text-white text-decoration-underline">Home</Link>
            <span>/</span>
            <span>About Us</span>
          </nav>
        </div>
      </header> */}

      <div className="title-section-about">
        <p className="small-text-about">Learn More </p>
        <h1>
          About <span>us</span>
        </h1>
        <Link to="/" className="Link">Home</Link>
        <span>/</span>
        <span>About Us</span>
      </div>

      <main>

        {/* Animated Navigation Section */}
        <AnimatedSection>
          <div className="container-fluid py-5 bg-light text-center">
            <h2 className="fw-semibold text-dark mb-4">Learn More</h2>
            <div className="d-flex justify-content-center flex-wrap gap-3">
              <a href="#vision-mission-section" className="btn btn-danger btn-lg px-5">
                What We Do?
              </a>
              <Link to="/founder" className="btn btn-outline-dark btn-lg px-5">
                Meet Our Founder
              </Link>
            </div>
            {/* Animated Intro Section */}
            <AnimatedSection>
              <div className="container-fluid bg-light py-5">
                <div className="mx-auto text-start px-3" style={{ maxWidth: "1200px" }}>
                  <p className="fs-5 lh-lg">
                    <h2 className="fw-semibold text-dark" style={{ fontSize: "2rem" }}>
                      What we do?
                    </h2>
                    <br />
                    CIRA Technology was founded in 2016 and in 2020 it got elevated as CIRA Technology Pvt Ltd,
                    at Cira we believe in equal opportunities with deep rooted values ensuring the utmost levels of Integrity & Ethics
                    and utilizing the Best Practices to generate highest Values for our Customers,
                  </p>
                  <p className="fs-5 lh-lg">We are one of the industry leading Solution providers related to </p>
                  <ul class="list-group list-group-flush fs-5 lh-lg "  style={{ backgroundColor: "#f8f9fa" }}>
                    <li class="list-group-item "  style={{ backgroundColor: "#f8f9fa" }}>Process Instruments (Flow, Level, Pressure, Temp., Analyzer)</li>
                    <li class="list-group-item"  style={{ backgroundColor: "#f8f9fa" }}>Automation (PLC/DCS)</li>
                    <li class="list-group-item"  style={{ backgroundColor: "#f8f9fa" }}>Valves (Control & ON/OFF)</li>
                  </ul>

                </div>
              </div>
            </AnimatedSection>

            {/* Animated Vision & Mission Section */}
            <AnimatedSection>
              <div id="vision-mission-section" className="container-fluid py-5">
               
                <div className="mx-auto text-start px-3" style={{ maxWidth: "1200px" }}>
                  <p className="fs-5 lh-lg">
                    @CIRA - We work as a consultant with our prestigious customers, we understand their Applications and Process Criticality and
                    do provide the Industry Best Solutions with our knowledge &
                    rich Experience which we hold across various industry verticals like F&B, Water, Power, Sugar, Cement, Chemical, Pulp & Paper.
                  </p>
                  <p className="fs-5 lh-lg">
                    We’re in this industry for the long haul, we aim to be your supplier of choice - in fact your most preferred supplier.
                    we hold an impressive Product Portfolio and related Product Solution’s
                    which has been built based on our customer expectations in terms of Quality, Service Support and greater Pricing.
                  </p>
                </div>
              </div>
            </AnimatedSection>


          </div>
        </AnimatedSection>
      </main>
    </>
  );
};

export default AboutUs;
